export default __webpack_public_path__ + "static/media/NRT 1.7f5ed230.png";